import { default as BarChart } from './BarChart';

export default BarChart;
